import {AnyElement, MuWidget} from "mu-widget/lib/MuWidget";
import {SlashTreeNode} from "../SlashTree";

export class UiTree extends MuWidget {
	muBindData(srcData: SlashTreeNode, params: any) {
		this.bindItems(srcData.items, this.ui.items || this.container, params);
	}

	bindItems(items: SlashTreeNode[], container: AnyElement|string, params: any = {}) {
		for(const item of items) {
			const w = this.muWidgetFromTemplate("ancestor:item", container, params);
			w.muBindData({ ...item.data, pathItemName: item.name });
			this.bindItems(item.items, w.ui.items, params);
		}
	}
}